<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="full blank">
            <div class="center_text surgery">
              <div class="imgWrap">
                <img src="@/assets/images/error.svg">
              </div>
              <div class="ct_content">
                <p>본인인증에 실패하였습니다.</p>
                <p>서비스 이용에 불편을 드려 죄송합니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible" @click="goMain()">
        <button type="button" class="callTerms">메인페이지 이동</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '본인인증 실패',
        prevUrl: '/'
      }
    }
  },
  methods: {
    goMain () {
      location.href = '/'
    },
    setParent () {
      window.opener.location.reload()
      self.close()
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/authorized')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    localStorage.removeItem('url')
  },
  components: {
    AppHeader,
    AppSidebar
  }
}
</script>

<style lang="scss" scoped>
</style>
